import { supabase, TABLES } from './supabase';
import { Player } from '../types/player';

export class PlayerService {
  // 获取所有活跃玩家
  static async getAllActivePlayers(): Promise<Player[]> {
    const { data, error } = await supabase
      .from(TABLES.PLAYERS)
      .select('*')
      .eq('is_active', true)
      .order('number');

    if (error) {
      throw new Error(`获取玩家列表失败: ${error.message}`);
    }

    return data.map(player => ({
      id: player.id,
      name: player.name,
      number: player.number,
      isActive: player.is_active,
      createdAt: new Date(player.created_at),
    }));
  }

  // 添加新玩家
  static async addPlayer(name: string, number: number): Promise<Player> {
    const { data, error } = await supabase
      .from(TABLES.PLAYERS)
      .insert({
        name,
        number,
        is_active: true,
      })
      .select()
      .single();

    if (error) {
      throw new Error(`添加玩家失败: ${error.message}`);
    }

    return {
      id: data.id,
      name: data.name,
      number: data.number,
      isActive: data.is_active,
      createdAt: new Date(data.created_at),
    };
  }

  // 移除玩家（软删除）
  static async removePlayer(playerId: string): Promise<void> {
    const { error } = await supabase
      .from(TABLES.PLAYERS)
      .update({ is_active: false })
      .eq('id', playerId);

    if (error) {
      throw new Error(`移除玩家失败: ${error.message}`);
    }
  }

  // 获取下一个可用的编号
  static async getNextAvailableNumber(): Promise<number> {
    const { data, error } = await supabase
      .from(TABLES.PLAYERS)
      .select('number')
      .eq('is_active', true)
      .order('number');

    if (error) {
      throw new Error(`获取编号失败: ${error.message}`);
    }

    const usedNumbers = data.map(p => p.number);
    let nextNumber = 1;
    
    while (usedNumbers.includes(nextNumber)) {
      nextNumber++;
    }

    return nextNumber;
  }

  // 初始化默认玩家
  static async initializeDefaultPlayers(): Promise<void> {
    const defaultPlayers = [
      { name: '杨', number: 1 },
      { name: '刁', number: 2 },
      { name: '张', number: 3 },
      { name: '李', number: 4 },
      { name: '谢', number: 5 },
    ];

    for (const player of defaultPlayers) {
      try {
        await this.addPlayer(player.name, player.number);
      } catch (error) {
        // 如果玩家已存在，忽略错误
        console.log(`玩家 ${player.name} 已存在，跳过创建`);
      }
    }
  }
}